const ISTWarehouseSVG = () => {
  return (
    `<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="22" fill="white" stroke="#9245CE" strokeWidth="2" />
      <g transform="translate(12, 12)">
        <path
          d="M1.375 10.25H2.5v11.375h2.22V11.75a.375.375 0 0 1 .375-.375h14.31a.375.375 
             0 0 1 .375.375v9.875H22V10.25h1.125a.376.376 0 0 0 .213-.684l-10.875-7.5a.37.37 0 0 
             0-.426 0l-10.875 7.5a.375.375 0 0 0 .213.684"
          fill="#9245CE"
        />
        <path
          d="M14.748 16.503a2.25 2.25 0 0 0-1.343.446l-1.356-1.355A2.248 2.248 0 0 0 9.3 12.21
             a2.249 2.249 0 1 0 2.295 3.84l1.353 1.355a2.247 2.247 0 0 0 1.345 3.548 2.25 2.25 0 0 
             0 1.85-3.966 2.25 2.25 0 0 0-1.396-.484m-6.105-2.249a1.606 1.606 0 1 1 3.211 0 
             1.606 1.606 0 0 1-3.211 0"
          fill="#9245CE"
        />
      </g>
    </svg>`
  );
};

export default ISTWarehouseSVG;
